import { z } from 'zod';

export const trainingCourseFilterSchema = (priceRange?: { min: number; max: number }) =>
  z
    .object({
      priceMin: z.number().nullable(),
      priceMax: z.number().nullable(),
    })
    .refine(
      (data) => {
        if (data.priceMin !== null && priceRange && data.priceMin < priceRange.min) return false;
        return true;
      },
      { path: ['priceMin'], message: 'priceMinBelowRange' }
    )
    .refine(
      (data) => {
        if (data.priceMax !== null && priceRange && data.priceMax > priceRange.max) return false;
        return true;
      },
      { path: ['priceMax'], message: 'priceMaxAboveRange' }
    )
    .refine(
      (data) => {
        if (data.priceMin !== null && data.priceMax !== null && data.priceMin > data.priceMax)
          return false;
        return true;
      },
      { path: ['priceMin'], message: 'priceMinAboveMax' }
    );
